import { render, staticRenderFns } from "./MshiptypesForm.vue?vue&type=template&id=d71b1224"
import script from "./MshiptypesForm.vue?vue&type=script&lang=js"
export * from "./MshiptypesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports